import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(regionId) {
  return yield oncallFetch(
    "/api/oncall/partners/regions/get-shifts-definitions",
    { id: regionId },
  );
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/regions/get-shifts-definitions.js